import useDebounceInput from 'customHooks/useDebounceInput'
import { fetchGetSupplyOrderDetailItem } from 'features/SupplyOrder/redux/outboundSOAddEdit'
import { useHistory, useParams } from 'react-router-dom'
import { shallowEqual, useAppDispatch, useAppSelector } from 'store'

const useProductDetail = () => {
  const history = useHistory()

  const { id } = useParams<{ id: string }>()
  const isEdit = Boolean(id)

  const dispatch = useAppDispatch()
  const { form, data } = useAppSelector((state) => state.outboundSOAddEdit, shallowEqual)

  const [search, handleSearch] = useDebounceInput({
    onChange: (val) => {
      dispatch(
        fetchGetSupplyOrderDetailItem({
          supplyOrderId: Number(id),
          params: {
            pageIndex: 0,
            name: val || undefined,
          },
        }),
      )
    },
  })

  const handleGoToAddProduct = () => {
    const createSOState = {
      ...form,
      createdBy: data?.supplyOrderCreatedBy,
      status: data?.supplyOrderStatus,
      supplyOrderId: id ? Number(id) : undefined,
    }
    localStorage.setItem('createSOState', JSON.stringify(createSOState))

    const isSoDirectType = createSOState.soType.toLowerCase() === 'direct'
    const isSoBadStock = createSOState.soType.toLowerCase() === 'bad stock'

    if (isSoDirectType || isSoBadStock) {
      history.push('/dashboard/outbound-so/add-product-direct')
      return
    }

    history.push('/dashboard/outbound-so/add-product')
  }

  return {
    isEdit,
    search,
    handleSearch,
    handleGoToAddProduct,
  }
}

export default useProductDetail
